let debugEnabled = false;
let stacktracesEnabled = false;
export function enableLogger(enable) {
  debugEnabled = enable;
}
export function enableStacktraces(enable) {
  stacktracesEnabled = enable;
}
export function logStacktrace() {
  if (stacktracesEnabled) {
    // eslint-disable-next-line no-console
    console.log(new Error().stack);
  }
}
export default function debug(msg, ...args) {
  if (debugEnabled) {
    // eslint-disable-next-line no-console
    console.log(msg, ...args);
  }
}